import { refCount, publish } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class HeaderDropdownService {
  public dropdownCloseObserver;
  public dropdownClose$;

  constructor() {
    const observable = new Observable((observer) => {
      this.dropdownCloseObserver = observer;
      return;
    });
    this.dropdownClose$ = observable.pipe(
      publish(),
      refCount(),
    );
  }

  close() {
    this.dropdownCloseObserver.next(true);
  }
}
